<template>
  <v-card
    class="elevation-1"
  >
    <v-layout
      pl-2
      align-center
    >
      <v-flex
        xs2
        pa-3
      >
        <v-icon
          class="background-icon"
          :style="`background: ${backgroundIconColor}`"
          :color="iconColor"
        >
          {{ icon }}
        </v-icon>
      </v-flex>
      <v-flex xs10>
        <span class="text-option"> {{ text }}</span>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: 'IconCard',
  props: {
    backgroundIconColor: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
  .background-icon {
    width: 5.2vh;
    height: 5.2vh;
    border-radius: 50%;
    text-decoration: none;
  }
  .text-option {
    font-weight: 600;
    font-size: 1.6vh;
    line-height: 2.4vh;
    color: #363333;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;
  }
  .v-card {
    cursor: pointer;
    border-radius: 0.8vh !important;
  }
</style>
